/* =========================================================================
   VRMB / Matt Landau theme — consolidated interactions (vanilla JS)
   No external dependencies. Respects prefers-reduced-motion.
   ========================================================================= */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Focus trap helper ---------------------------------------------- */
  function trapFocus(container) {
    var focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return function () {};
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    function onKey(e) {
      if (e.key !== "Tab") return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
    container.addEventListener("keydown", onKey);
    return function () { container.removeEventListener("keydown", onKey); };
  }

  /* ---- Mobile drawer --------------------------------------------------- */
  function initDrawer() {
    var drawer = document.querySelector("[data-drawer]");
    var openBtn = document.querySelector("[data-drawer-open]");
    var closeEls = document.querySelectorAll("[data-drawer-close]");
    if (!drawer || !openBtn) return;
    var release = function () {};
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.setAttribute("data-open", "true");
      drawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      release = trapFocus(drawer);
      var firstLink = drawer.querySelector("a, button");
      if (firstLink) firstLink.focus();
    }
    function close() {
      drawer.setAttribute("data-open", "false");
      drawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      release();
      if (lastFocused) lastFocused.focus();
    }
    openBtn.addEventListener("click", open);
    closeEls.forEach(function (el) { el.addEventListener("click", close); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.getAttribute("data-open") === "true") close();
    });
  }

  /* ---- Generic modals (Join / Story / Legal) -------------------------- */
  function initModals() {
    var releases = {};
    var lastFocused = {};

    function openModal(modal) {
      if (!modal) return;
      lastFocused[modal.id] = document.activeElement;
      modal.setAttribute("data-open", "true");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      releases[modal.id] = trapFocus(modal);
      var focusEl = modal.querySelector("[data-autofocus], button, a, input");
      if (focusEl) focusEl.focus();
    }
    function closeModal(modal) {
      if (!modal) return;
      modal.setAttribute("data-open", "false");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      if (releases[modal.id]) releases[modal.id]();
      if (lastFocused[modal.id]) lastFocused[modal.id].focus();
    }

    // Open triggers — data-modal-open="modalId" plus optional data-modal-preselect
    document.querySelectorAll("[data-modal-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-modal-open");
        var modal = document.getElementById(id);
        var preselect = btn.getAttribute("data-modal-preselect");
        if (preselect && modal) applyPreselect(modal, preselect.split(","));
        openModal(modal);
      });
    });
    // Close triggers
    document.querySelectorAll("[data-modal-close]").forEach(function (el) {
      el.addEventListener("click", function () {
        closeModal(el.closest(".modal"));
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      document.querySelectorAll('.modal[data-open="true"]').forEach(closeModal);
    });

    // Story modal: fill content from clicked card's data-* attributes
    var storyModal = document.getElementById("story-modal");
    if (storyModal) {
      document.querySelectorAll("[data-story]").forEach(function (card) {
        card.addEventListener("click", function () {
          fillStory(storyModal, card.dataset);
          openModal(storyModal);
        });
        card.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); fillStory(storyModal, card.dataset); openModal(storyModal); }
        });
      });
    }

    window.__openModal = function (id) { openModal(document.getElementById(id)); };
  }

  function applyPreselect(modal, ids) {
    modal.querySelectorAll("[data-option]").forEach(function (opt) {
      var on = ids.indexOf(opt.getAttribute("data-option")) !== -1;
      setToggle(opt, on);
    });
    syncPhoneField(modal);
  }

  function isSafeImageSrc(s) {
    if (!s) return false;
    var v = String(s).trim().toLowerCase();
    if (v.indexOf("javascript:") === 0 || v.indexOf("data:") === 0 || v.indexOf("vbscript:") === 0) return false;
    return /^(https?:)?\/\//.test(v) || v.charAt(0) === "/";
  }

  function fillStory(modal, data) {
    var set = function (sel, val) {
      var el = modal.querySelector(sel);
      if (el) el.textContent = val || "";
    };
    set("[data-story-tags]", data.tags || "STORY");
    set("[data-story-title]", data.title || "");
    set("[data-story-people]", (data.name || "") + (data.role ? " · " + data.role : ""));
    set("[data-story-body]", data.full || data.excerpt || "");
    var img = modal.querySelector("[data-story-image]");
    if (img) {
      if (isSafeImageSrc(data.image)) {
        img.src = data.image;
        img.alt = data.name || data.title || "";
      } else {
        img.removeAttribute("src");
        img.alt = data.name || data.title || "";
      }
    }
  }

  /* ---- Subscription option toggles ------------------------------------ */
  function setToggle(btn, on) {
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    var hidden = document.getElementById(btn.getAttribute("data-option-input"));
    if (hidden) hidden.disabled = !on;
  }
  function syncPhoneField(scope) {
    // Reveal the phone field when any "sms"-type option is enabled.
    var smsBtn = scope.querySelector('[data-option="sms"]');
    if (!smsBtn) {
      var candidates = scope.querySelectorAll("[data-option]");
      for (var i = 0; i < candidates.length; i++) {
        if (/sms/i.test(candidates[i].getAttribute("data-option") || "")) { smsBtn = candidates[i]; break; }
      }
    }
    var phoneWrap = scope.querySelector("[data-phone-field]");
    if (smsBtn && phoneWrap) {
      var on = smsBtn.getAttribute("aria-pressed") === "true";
      phoneWrap.hidden = !on;
      var input = phoneWrap.querySelector("input");
      if (input) input.required = on;
    }
  }
  function initToggles() {
    document.querySelectorAll("[data-option]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var on = btn.getAttribute("aria-pressed") !== "true";
        setToggle(btn, on);
        syncPhoneField(btn.closest(".modal") || document);
      });
    });
    document.querySelectorAll(".modal").forEach(syncPhoneField);
  }

  /* ---- Story slider arrows -------------------------------------------- */
  function initSlider() {
    document.querySelectorAll("[data-slider]").forEach(function (slider) {
      var track = slider.querySelector("[data-slider-track]");
      var prev = slider.querySelector("[data-slider-prev]");
      var next = slider.querySelector("[data-slider-next]");
      if (!track) return;
      var amount = function () { return Math.max(320, track.clientWidth * 0.4); };
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -amount(), behavior: reduceMotion ? "auto" : "smooth" }); });
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: amount(), behavior: reduceMotion ? "auto" : "smooth" }); });
    });
  }

  /* ---- Scroll reveal --------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!els.length || reduceMotion || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Active nav state on scroll ------------------------------------- */
  function initScrollSpy() {
    var links = document.querySelectorAll("[data-spy]");
    if (!links.length || !("IntersectionObserver" in window)) return;
    var map = {};
    links.forEach(function (l) {
      var id = l.getAttribute("data-spy");
      var sec = document.getElementById(id);
      if (sec) map[id] = l;
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var link = map[entry.target.id];
        if (link && entry.isIntersecting) {
          links.forEach(function (l) { l.removeAttribute("aria-current"); });
          link.setAttribute("aria-current", "true");
        }
      });
    }, { threshold: 0.5 });
    Object.keys(map).forEach(function (id) {
      var sec = document.getElementById(id);
      if (sec) io.observe(sec);
    });
  }

  /* ---- Header scrolled state (toggle class when page scrolled) ------- */
  function initHeaderScroll() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    var ticking = false;
    function update() {
      ticking = false;
      if (window.scrollY > 8) header.classList.add("is-scrolled");
      else header.classList.remove("is-scrolled");
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
  }

  /* ---- Inquiry form: dual-send (Shopify + Resend instant ack) ----------
     Resend config (endpoint + form_type) lives on a wrapper <div> because
     Shopify's {% form %} tag doesn't reliably accept hyphenated data-* attrs. */
  function initInquiryResend() {
    var wraps = document.querySelectorAll('[data-resend-endpoint]');
    if (!wraps.length) return;

    Array.prototype.forEach.call(wraps, function (wrap) {
      var endpoint = wrap.getAttribute('data-resend-endpoint');
      if (!endpoint) return; // Resend not configured — Shopify submit alone is fine

      var form = wrap.querySelector('form');
      if (!form) return;

      var formType = wrap.getAttribute('data-form-type') || 'Inquiry';

      // Stamp the form-load timestamp the moment we wire up
      var timeField = form.querySelector('[data-form-time]');
      var loadedAt = Date.now();
      if (timeField) timeField.value = String(loadedAt);

      var submitted = false;
      form.addEventListener('submit', function (evt) {
        if (submitted) return; // second pass — let it through to Shopify
        submitted = true;
        evt.preventDefault();

        // Collect fields → JSON payload for the Worker
        var data = new FormData(form);
        var payload = {
          form_type: formType || data.get('contact[form_type]') || 'Inquiry',
          email: data.get('contact[email]') || '',
          name: data.get('contact[name]') || '',
          company: data.get('contact[company]') || '',
          website: data.get('contact[website]') || '', // honeypot
          form_time_ms: Date.now() - loadedAt,
        };

        // Fire-and-wait with hard timeout so Shopify submission isn't blocked
        var controller = new AbortController();
        var timeoutId = setTimeout(function () { controller.abort(); }, 3000);

        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          signal: controller.signal,
          keepalive: true,
        }).catch(function () {
          // Silent — Shopify still gets the lead, we never block on Resend
        }).finally(function () {
          clearTimeout(timeoutId);
          // Continue with the native Shopify submission
          form.submit();
        });
      });
    });
  }

  /* ---- Signup forms: notify ops on every submit -----------------------
     Customer forms (hero, concept, weekly-call, signup, modal) create a
     Shopify customer record + tags but don't email anyone. This sends an
     internal notification to ops via the same Resend Worker on EVERY submit,
     including duplicates — Shopify's customer record stays idempotent, but
     the notification is not. */
  function initSignupNotify() {
    var wraps = document.querySelectorAll('[data-notify-endpoint]');
    if (!wraps.length) return;

    Array.prototype.forEach.call(wraps, function (wrap) {
      var endpoint = wrap.getAttribute('data-notify-endpoint');
      if (!endpoint) return; // Worker not configured — Shopify submit alone is fine

      var form = wrap.querySelector('form');
      if (!form) return;

      var signupSource = wrap.getAttribute('data-signup-source') || 'Unknown signup';

      var submitted = false;
      form.addEventListener('submit', function () {
        if (submitted) return; // second pass (form.submit() programmatic) — let it through
        submitted = true;

        // Scoop every contact[*] field dynamically so future fields work without code changes
        var data = new FormData(form);
        var fields = {}; // notes only — flat key:value for display
        var email = '';
        var firstName = '';
        var lastName = '';
        var phone = '';
        var tags = '';

        data.forEach(function (value, key) {
          if (!value) return;
          if (key === 'contact[email]') email = String(value);
          else if (key === 'contact[first_name]') firstName = String(value);
          else if (key === 'contact[last_name]') lastName = String(value);
          else if (key === 'contact[phone]') phone = String(value);
          else if (key === 'contact[tags]') tags = String(value);
          else if (key.indexOf('contact[note][') === 0) {
            // Extract the note key name from contact[note][KEY]
            var noteKey = key.slice('contact[note]['.length, -1);
            fields[noteKey] = String(value);
          }
        });

        if (phone) fields.Phone = phone;

        var name = (firstName + ' ' + lastName).trim();

        var payload = {
          mode: 'ops-notify',
          signup_source: signupSource,
          email: email,
          name: name,
          tags: tags,
          fields: fields,
          source_url: window.location.href,
          timestamp: new Date().toISOString(),
        };

        // Fire-and-forget. We do NOT preventDefault — Shopify submission proceeds
        // normally in parallel. keepalive lets the fetch survive the page navigation.
        try {
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            keepalive: true,
          }).catch(function () {
            // Silent — Shopify still gets the customer record, this is a best-effort notification
          });
        } catch (e) { /* silent */ }
      });
    });
  }

  /* ---- Join modal: success state across page reload --------------------
     Shopify customer forms reload the page on submit. To show the visitor
     a clear confirmation on the modal after submit, we:
       1. On submit, set a sessionStorage flag BEFORE the native submit fires
       2. On next page load, if the flag is set, swap to success state and
          auto-open the modal — then clear the flag so it only fires once. */
  function initJoinModalSuccess() {
    var KEY = 'vrmbJoinModalJustSubmitted';
    var modal = document.getElementById('join-modal');
    if (!modal) return;

    var formEl = modal.querySelector('#join-modal-form');
    var formState = modal.querySelector('.join-modal__form-state');
    var successState = modal.querySelector('.join-modal__success-state');

    // 1. Tag the form so we know its submission triggered this
    if (formEl) {
      formEl.addEventListener('submit', function () {
        try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* private mode etc. */ }
      });
    }

    // 2. On load, if the flag is set, show success state and auto-open
    var justSubmitted;
    try { justSubmitted = sessionStorage.getItem(KEY) === '1'; } catch (e) { justSubmitted = false; }

    if (justSubmitted && formState && successState) {
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      formState.hidden = true;
      successState.hidden = false;
      if (window.__openModal) window.__openModal('join-modal');
    }
  }

  /* ---- Init ------------------------------------------------------------ */
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () {
    initDrawer();
    initModals();
    initToggles();
    initSlider();
    initReveal();
    initScrollSpy();
    initHeaderScroll();
    initInquiryResend();
    initSignupNotify();
    initJoinModalSuccess();
  });
})();
